module.exports = __webpack_public_path__ + "static/media/Taric.6565768d.png";